/**
 * Created by Mohamed on 5/22/2016.
 */
(function (angular) {

	// Should be set when service injection
	var _instance;
	var _tsSideBarService;
	var _tsCommunicationService;
	var _teamScheduleService;
    var _hUser;

	var _activeTab;
	var _sideBarOpen;
	var _windowFocused = true;
	var _lastTrigger = 0;
	var _lastTimeUserActive = Date.now();
	var _prevMousePosition = {};

	var TSPullingService = function () {
		var self = this;

		var services = {
			"teamWall": {
				ON_ACTIVE_DELAY: 10 * 1000,
				callback: null,
				lastCheck: 0,
				lastTimeUserActive: 0,
				prevMousePosition: {}
			},
            "employeeTeamWall": {
                ON_ACTIVE_DELAY: 3600 * 1000,
                callback: null,
                lastCheck: 0,
                lastTimeUserActive: 0,
                prevMousePosition: {}
            },
            "employeeTeamCommunication": {
                ON_ACTIVE_DELAY: 3600 * 1000,
                callback: null,
                lastCheck: 0,
                lastTimeUserActive: 0,
                prevMousePosition: {}
            },
			"messages": {
				ON_ACTIVE_DELAY: 10 * 1000,
				callback: null,
				lastCheck: 0,
				lastTimeUserActive: 0,
				prevMousePosition: {}
			},
			"conversations": {
				ON_ACTIVE_DELAY: 10 * 1000,
				callback: null,
				lastCheck: 0,
				lastTimeUserActive: 0,
				prevMousePosition: {}
			},
			"timeOffs": {
				ON_ACTIVE_DELAY: 60 * 1000,
				callback: null,
				lastCheck: 0,
				lastTimeUserActive: 0,
				prevMousePosition: {}
			},
			"teamCommunication": {
				ON_ACTIVE_DELAY: 60 * 1000,
				callback: null,
				lastCheck: 0,
				lastTimeUserActive: 0,
				prevMousePosition: {},
				FORCE_CHECK: true
			}
		};

		self.registerService = function (service, callback) {
			services[service].callback = callback;

			if (callback && (service == _activeTab || services[service].FORCE_CHECK)) {
				applyPullingPolicy(true);
			}
		};

		self.offService = function (service) {
            delete services[service].callback;
        };

		_tsSideBarService.onChange(function (isOpen) {
			_sideBarOpen = isOpen;
			applyPullingPolicy(isOpen);
		});

		_teamScheduleService.onBrandChanged(function () {
			applyPullingPolicy(true);
		});

		_tsCommunicationService.onActiveChanged(function (activeTab) {
			if (activeTab != _activeTab) {
				_activeTab = activeTab;
				applyPullingPolicy(true);
			}
		});

		$(window).on("focus", function () {
			_windowFocused = true;
			applyPullingPolicy(true);
		});

		$(window).on("blur", function () {
			_windowFocused = false;
			applyPullingPolicy();
		});

		$(document).on("mousemove touchmove", function (event) {
			for (var i in services) {
				if (services[i].callback) {
					if (Date.now() - services[i].lastTimeUserActive > services[i].ON_ACTIVE_DELAY) {
						var target = event;

						if (event.touches && event.touches[0]) {
							target = event.touches[0];
						}

						if (target.pageX != _prevMousePosition.pageX || target.pageY != _prevMousePosition.pageY) {
							services[i].lastTimeUserActive = Date.now();
							services[i].prevMousePosition = {
								pageX: target.pageX,
								pageY: target.pageY
							};
							applyPullingPolicy(true);
						}
					}
				}
			}
		});

		$(document).on("keydown", function (event) {
			for (var i in services) {
				if (services[i].callback) {
					if (Date.now() - services[i].lastTimeUserActive > services[i].ON_ACTIVE_DELAY) {
						services[i].lastTimeUserActive = Date.now();
						applyPullingPolicy(true);
					}
				}
			}
		});

		var applyPullingPolicy = function (force) {

            if (!_hUser.isLoggedIn()) {
                console.warn("Pulling service disabled, user isLoggedIn:", _hUser.isLoggedIn());
                return;
            }

			var DELAY = 60 * 60 * 1000; // 1 hour

			if (_sideBarOpen) {
				DELAY = 10 * 60 * 1000; // 10 minutes

				if (_windowFocused) {
					DELAY = 2 * 60 * 1000; // 2 minutes
				}

				if (force) {
					DELAY = 1; // 1 ms, immediate
				}
			}

			setTimeout(function () {
				applyPullingPolicy();
                if (_hUser.isLoggedIn()) {
                    for (let i in services) {
                        if ((Date.now() - services[i].lastCheck) >= services[i].ON_ACTIVE_DELAY) {
                            services[i].lastCheck = Date.now();
                            services[i] && services[i].callback && services[i].callback();
                        }
                    }
                }
			}, DELAY);
		};
	};

	angular
			.module('harriApp')
			.service('TSPullingService', ["hUser", "TSSideBarService", "TeamCommunicationService", "TeamScheduleService", function (hUser, TSSideBarService, TeamCommunicationService, TeamScheduleService) {
				return {
					init: function () {
						if (!_instance) {
							_tsCommunicationService = new TeamCommunicationService();
							_tsSideBarService = new TSSideBarService();
							_teamScheduleService = TeamScheduleService;
							_hUser = hUser;
							_instance = new TSPullingService();
						}

						return _instance;
					}
				};
			}]);

})(angular);